import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import LoadingScreen from '@/components/common/LoadingScreen';
import Layout from '@/components/layout/Layout';
import ProtectedRoute from '@/components/common/ProtectedRoute';

// 懒加载页面组件
const LoginPage = lazy(() => import('@/pages/LoginPage'));
const AuthCallbackPage = lazy(() => import('@/pages/AuthCallbackPage'));
const RegisterPage = lazy(() => import('@/pages/RegisterPage'));
const QuizListPage = lazy(() => import('@/pages/QuizListPage'));
const QuizPage = lazy(() => import('@/pages/QuizPage'));
const ResultPage = lazy(() => import('@/pages/ResultPage'));

function App() {
  return (
    <Router>
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          {/* 企业微信登录相关路由 */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />

          {/* 保留原有的注册页面（可选的备用登录方式） */}
          <Route path="/register" element={<RegisterPage />} />

          {/* 受保护的主应用路由 */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<QuizListPage />} />
            <Route path="quiz/:quizId" element={<QuizPage />} />
            <Route path="result/:attemptId" element={<ResultPage />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;